export { default as useRegisterNotifications } from "./useRegisterNotifications";
